var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:({
    customClass: 'cc-popover',
    title: '',
    content: _vm.name,
    delay: { show: 800 },
  }),expression:"{\n    customClass: 'cc-popover',\n    title: '',\n    content: name,\n    delay: { show: 800 },\n  }",modifiers:{"hover":true,"top":true}}],staticClass:"cc-preview-sm",class:{ active: _vm.selected },on:{"click":function($event){return _setup.emits('click')}}},[_c(_setup.CcIcon,{attrs:{"type":_vm.icon,"height":22}}),_c('span',[_vm._v(_vm._s(_vm.name))]),_c(_setup.CcSwitch,{staticClass:"cc-switch--green",attrs:{"disabled":_vm.disableStatusChange,"value":_vm.active},on:{"update":_setup.togglePreviewCard}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }